define('modules/campaigns/modal/play_ad_modal',[
  'backbone',
  'jquery',
  '_',
  'moment',
  'text!./play_ad_modal_template.html',
  'session'
], function (Backbone, $, _,
  moment,
  modal_template,
  session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'play-ad-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-play-ad': 'playAd'
    },

    render: function () {
      this.$el.html(this.template({bookingIds: this.bookingIds}));
      return this;
    },

    playAd: function (e) {
      e.preventDefault();

      Backbone.trigger('campaigns:playads', {
        'bookingIds': this.bookingIds,
        'locationCode': this.locationCode
      });
      this.trigger('close');
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

